import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Modal,
} from "@mui/material";
import bgImg from "../../assets/landing/FeaturedSection/bgImg.jpg";
import catImg1 from "../../assets/landing/FeaturedSection/img-01.jpg";
import catImg2 from "../../assets/landing/FeaturedSection/img-02.jpg";
import catImg3 from "../../assets/landing/FeaturedSection/img-03.jpg";

const FeaturedSection = () => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  const featuredCategories = [
    { id: 1, name: "Plumeria Plants", image: catImg1 },
    { id: 2, name: "Plumeria Cuttings", image: catImg2 },
    { id: 3, name: "Plumeria Seeds", image: catImg3 },
  ];

  const backgroundStyle = {
    backgroundImage: `url(${bgImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    px: 2,
  };

  return (
    <Box sx={backgroundStyle}>
      <Box sx={{ maxWidth: 1200, mx: "auto", width: "100%" }}>
        <Box
          sx={{
            textAlign: "center",
            py: 6,
            px: 2,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            borderRadius: 4,
          }}
        >
          {/* Title */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              mb: 6,
            }}
          >
            <Box sx={{ flex: 1, borderBottom: "2px solid #31B44B" }} />
            <Typography
              variant="h4"
              sx={{
                color: "white",
                fontWeight: "bold",
                mx: 2,
              }}
            >
              Featured Categories
            </Typography>
            <Box sx={{ flex: 1, borderBottom: "2px solid #31B44B" }} />
          </Box>

          {/* Cards */}
          <Grid
            container
            spacing={4}
            justifyContent="center"
            pb={4}
            sx={{ borderBottom: "1px solid #31B44B" }}
          >
            {featuredCategories.map((category) => (
              <Grid
                item
                key={category.id}
                xs={12}
                sm={12}
                md={4}
                display="flex"
                justifyContent="center"
              >
                <Card
                  sx={{
                    maxWidth: 345,
                    width: "100%",
                    textAlign: "center",
                    boxShadow: 3,
                    backgroundColor: "white",
                  }}
                >
                  <Box sx={{ p: 2 }}>
                    <CardMedia
                      component="img"
                      height="200"
                      image={category.image}
                      alt={category.name}
                      onClick={() => handleOpen(category.image)}
                      sx={{
                        objectFit: "cover",
                        cursor: "pointer",
                        transition: "transform 0.4s ease",
                        "&:hover": {
                          transform: "scale(1.05)",
                        },
                      }}
                    />
                  </Box>
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{ mb: 2, color: "#232323", fontWeight: "bold" }}
                    >
                      {category.name}
                    </Typography>
                    <Button
                      variant="outlined"
                      sx={{
                        px: 4,
                        py: 1,
                        borderColor: "#31B44B",
                        color: "#31B44B",
                        borderRadius: 0,
                        fontWeight: "bold",
                        "&:hover": {
                          backgroundColor: "#31B44B",
                          color: "white",
                        },
                      }}
                    >
                      VIEW PRODUCTS
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>

      {/* Modal for enlarged image */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            outline: "none",
            maxWidth: "90%",
            maxHeight: "90%",
          }}
        >
          {selectedImage && (
            <Box
              component="img"
              src={selectedImage}
              alt="Enlarged"
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: 2,
                boxShadow: 5,
              }}
            />
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default FeaturedSection;
